module.exports = "/_next/static/images/norwegian-ed4f8423c50e524a36ce611ae17a2cb4.svg";